module.exports = __webpack_public_path__ + "static/media/1.a8f40b66.jpeg";